// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_t1hSX {
  width: 496px;
  max-height: 204px;
  display: flex;
  flex-direction: column;
}

.cancelButton_DzcRT {
  max-width: 120px;
}


.dialogHeader_GW3P1 {
  height : 48px;
  padding: var(--size-pad12) var(--size-padLarge);
  border-bottom: 1px solid var(--color-base100);
}

.headerIcon_tj7Ko {
  background-color: #D0EBFF;
  width: 24px;
  height: 24px;
}
.headerIcon_tj7Ko > i {
  font-size: 10px;
}

.dialogBody_cWjpH {
  height : 84px;
  background-color: 'white';
}
.dialogBody_cWjpH > * + * {
  margin-top: var(--size-padLarge);
}

.dialogBodyText_UgS26 {
  font-size : 16px;
  padding : 16px;
  position : relative;
}

.dialogFooter_RnxgM {
  height : 72px;
  padding: var(--size-padLarge);
}

.formLabel_CB64g {
  margin-bottom: var(--size-padSmall);
}

/* Overriding default Toast's styling */
.toast_aZ3Cl {
  border-radius: var(--size-borderRadiusMedium) !important;
  min-height: 40px !important;
  padding: var(--size-padMedium) !important;
}
.toast_aZ3Cl > button {
  margin-top: 0 !important;
  width: 24px !important;
  height: 24px !important;
}

.icon_xD7QM {
  width: 24px;
  margin-left : 8px;
  margin-right : 8px;
}

.input_unZO5 {
  padding-left : 0px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/ownershipTransfer/actions/completeAssetTransfer/RejectTransferClasses.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uCAAuC;AACvC;EACE,wDAAwD;EACxD,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".dialog {\n  width: 496px;\n  max-height: 204px;\n  display: flex;\n  flex-direction: column;\n}\n\n.cancelButton {\n  max-width: 120px;\n}\n\n\n.dialogHeader {\n  height : 48px;\n  padding: var(--size-pad12) var(--size-padLarge);\n  border-bottom: 1px solid var(--color-base100);\n}\n\n.headerIcon {\n  background-color: #D0EBFF;\n  width: 24px;\n  height: 24px;\n}\n.headerIcon > i {\n  font-size: 10px;\n}\n\n.dialogBody {\n  height : 84px;\n  background-color: 'white';\n}\n.dialogBody > * + * {\n  margin-top: var(--size-padLarge);\n}\n\n.dialogBodyText {\n  font-size : 16px;\n  padding : 16px;\n  position : relative;\n}\n\n.dialogFooter {\n  height : 72px;\n  padding: var(--size-padLarge);\n}\n\n.formLabel {\n  margin-bottom: var(--size-padSmall);\n}\n\n/* Overriding default Toast's styling */\n.toast {\n  border-radius: var(--size-borderRadiusMedium) !important;\n  min-height: 40px !important;\n  padding: var(--size-padMedium) !important;\n}\n.toast > button {\n  margin-top: 0 !important;\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.icon {\n  width: 24px;\n  margin-left : 8px;\n  margin-right : 8px;\n}\n\n.input {\n  padding-left : 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_t1hSX`,
	"cancelButton": `cancelButton_DzcRT`,
	"dialogHeader": `dialogHeader_GW3P1`,
	"headerIcon": `headerIcon_tj7Ko`,
	"dialogBody": `dialogBody_cWjpH`,
	"dialogBodyText": `dialogBodyText_UgS26`,
	"dialogFooter": `dialogFooter_RnxgM`,
	"formLabel": `formLabel_CB64g`,
	"toast": `toast_aZ3Cl`,
	"icon": `icon_xD7QM`,
	"input": `input_unZO5`
};
export default ___CSS_LOADER_EXPORT___;
